<template>
  <span :class="['odds-bet', { 'active_':isChange },{ 'active_0': increase === 0 }, { 'active_0': increase === 1 }]" v-if="type">{{ newOdds }}</span>
  <span :class="['odds-txt', { 'active_':isChange },{ 'active_0': increase === 0 }, { 'active_1': increase === 1 }]" v-else>{{ newOdds }}</span>
</template>

<script>
  export default {
    props: {
      odds: {
        type: Number,
        default: 0
      },
      type:{
        type: String,
        default:''
      }
    },
    data() {
      return {
        newOdds: -1,
        timer: null,
        isChange: false, // 数值是否在变化中
        increase: null // 0 递减 1 递增
      }
    },
    watch: {
      odds(v, v1) {
        if (v1 >= 0 && v !== v1) this.oddsChange(v, v1)
      }
    },
    created() {
      this.newOdds = this.odds * 1
    },
    methods: {
      oddsChange(v, v1) {
        // console.log(v, v1)
        if(this.timer) {
          clearInterval(this.timer)
          this.newOdds = v1 * 1
        }
        this.increase = v - v1 > 0 ? 1 : 0
        const step = (Math.abs(v - v1) / 6).toFixed(3) * 1
        this.timer = setInterval(() => {
          this.isChange = !this.isChange
          if (this.increase === 1) this.newOdds += step
          if (this.increase === 0) this.newOdds -= step

          if ((this.increase === 1 && this.newOdds >= this.odds) || this.increase === 0 && this.newOdds <= this.odds) {
            this.newOdds = this.odds * 1
            this.isChange = false
            this.increase = null
            clearInterval(this.timer)
          }

          this.newOdds = this.newOdds.toFixed(3) * 1 // 变化过程防止数值过长
        }, 500)
      }
    },
    destroyed() {
      if(this.timer) clearInterval(this.timer)
    }
  }
</script>

<style lang="scss" scoped>
  .odds-txt{
    display:block;
    border-radius: 6px;
    &.active_.active_0{ background-color:#E83232!important;color:#323232!important;}
    &.active_.active_1{ background-color:#0ED000!important;color:#323232!important;}
  }
  .odds-bet{
    display:block;
    border-radius: 6px;
    &.active_.active_0{ background-color:#fdff03!important;color:#323232!important;}
  }
</style>



// WEBPACK FOOTER //
// src/pages/build902/components/new-home/odds.vue